import { mobile, styled, useQuery, Text, notDesktop } from '@obvio/app'
import { SvgArrowDown } from '@obvio/svg'
import { useSearchMeta } from '@obvio/template'
import { Button, Grid, Loading, Section, Stack } from '@obvio/ui'

import { PRODUCT_SELECT } from './StorePage'
import { ProductTile } from './StorePage/ProductTile'
import { FadeIn } from '../FadeIn'

import type { ReactElement } from 'react'

const Wrap = styled(Grid)`
  --masonry-spacing: ${(theme) => theme.spacing.large};
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: var(--masonry-spacing);
  @media ${notDesktop} {
    grid-template-columns: 1fr;
  }
`

const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--masonry-spacing);
`

const RatioProductTile = styled(ProductTile)`
  height: auto;
`
const CenterButton = styled(Button)`
  display: block;
  margin: 0 auto;
  @media ${mobile} {
    margin-top: 3rem;
  }
`

const CenterStack = styled(Stack)`
  align-items: center;
`

const everyNth = (arr: any[] | null, nth: number) =>
  arr?.filter((_e, i) => i % 3 === nth - 1)

export function ProductsGridTest(): ReactElement {
  const { category, params, ready } = useSearchMeta()

  const queryTake = 12
  const saleFilter = category === 'sale'

  const { sort, sortOrder, search, ...attributes } = params
  const { data, fetchMore, loading } = useQuery('getProducts', {
    select: PRODUCT_SELECT,
    withoutArgs: 'WAIT',
    args: ready
      ? {
          ...(sort
            ? { sort: { by: sort, order: sortOrder ?? 'desc' } }
            : { sort: { by: 'orderIndex', order: 'asc' } }),
          take: queryTake,
          title: search ?? '',
          ...(saleFilter && { onSale: saleFilter }),
          byAttributes: Object.entries(attributes).map(([key, value]) => ({
            attribute: key,
            values: typeof value === 'string' ? [value] : value,
          })) as { attribute: string; values: string[] }[],
        }
      : null,
  })

  const firstColumn = everyNth(data, 1)
  const secondColumn = everyNth(data, 2)
  const thirdColumn = everyNth(data, 3)

  return (
    <Section>
      <FadeIn>
        <Wrap>
          <Column>
            {firstColumn?.map((product) => (
              <RatioProductTile product={product} key={product.id} />
            ))}
          </Column>
          <Column>
            {secondColumn?.map((product) => (
              <RatioProductTile product={product} key={product.id} />
            ))}
          </Column>
          <Column>
            {thirdColumn?.map((product) => (
              <RatioProductTile product={product} key={product.id} />
            ))}
          </Column>
        </Wrap>
        {loading ? (
          <Loading />
        ) : (
          <CenterButton
            kind="transparent"
            onClick={() => fetchMore({ after: data?.[data.length - 1].id })}
          >
            <CenterStack spacing="extraSmall">
              <Text tag="span">Expand</Text>
              <SvgArrowDown height="1.2rem" width="1.2rem" strokeWidth="1px" />
            </CenterStack>
          </CenterButton>
        )}
      </FadeIn>
    </Section>
  )
}
